import { axiosObject } from "../config";

function bidInterest(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/bid-interests/_create";

    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBidInterest(user_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/bid-interests/_read";

    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 100,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "user_uuid",
          op: "eq",
          value: user_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { bidInterest, getBidInterest };
